"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchInstalledEcommerceAppIdsRequestStatus = exports.getIsEcommerceIntegrationConnected = exports.getDisconnectShopifyRequestStatus = exports.getFetchShopifyStatusRequestStatus = exports.getShopifyStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("../RequestStatuses/getRequestStatus"));

var _reselect = require("reselect");

var _actions = require("./actions");

var getEcommerceState = function getEcommerceState(state) {
  return state.modules.ecommerce.ecommerce;
};

var getShopifyStatus = (0, _reselect.createSelector)([getEcommerceState], function (state) {
  return state.get('integrationStatus');
});
exports.getShopifyStatus = getShopifyStatus;
var getFetchShopifyStatusRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceActionTypes.FETCH_SHOPIFY_STATUS);
exports.getFetchShopifyStatusRequestStatus = getFetchShopifyStatusRequestStatus;
var getDisconnectShopifyRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceActionTypes.DISCONNECT_SHOPIFY);
exports.getDisconnectShopifyRequestStatus = getDisconnectShopifyRequestStatus;
var getIsEcommerceIntegrationConnected = (0, _reselect.createSelector)([getEcommerceState], function (state) {
  return state.get('ecommBridgeAppIsInstalled');
});
exports.getIsEcommerceIntegrationConnected = getIsEcommerceIntegrationConnected;
var getFetchInstalledEcommerceAppIdsRequestStatus = (0, _getRequestStatus.default)(_actions.EcommerceActionTypes.FETCH_INSTALLED_ECOMMERCE_APP_IDS);
exports.getFetchInstalledEcommerceAppIdsRequestStatus = getFetchInstalledEcommerceAppIdsRequestStatus;